import { Disclosure } from "@headlessui/react";
import { Link } from "react-router-dom";
import ExpandingPanel from "../../../components/expanding-panel";
import Copy from "../../../components/icons/copy";
import Pencil from "../../../components/icons/pencil";
import SpinArrow from "../../../components/spin-arrow";
import { RuleSetList } from "../../../models/ruleset";

type RuleSetDisplayProps = {
  ruleset: RuleSetList;
};

const RuleSetDisplay = (props: RuleSetDisplayProps) => {
  const ruleset = props.ruleset;

  return (
    <div className="w-full border cursor-pointer bg-white shadow-sm rounded-lg flex items-center justify-items-stretch">
      <div className="w-full">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={`p-12 pr-6 ${
                  open ? "pb-0 mb-0" : "pb-4 mb-4"
                } flex-grow mb-4 relative flex items-center text-left justify-start w-full outline-none focus:outline-none`}
              >
                {ruleset.isActive && !ruleset.isInternal && (
                  <div className="h-4 w-4 rounded-full bg-green-600 absolute top-3 left-3 has-tooltip">
                    <div className="tooltip text-xs absolute -top-4 left-6">
                      <div className="flex items-center justify-start">
                        <div className="bg-white rounded p-2 shadow-md border-gray-100">
                          Active Ruleset
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex-grow">
                  <div className="uppercase text-primary-blue text-lg font-semibold tracking-[0.07rem]">
                    {ruleset.name}
                  </div>
                  <div className="text-sm font-light text-gray-500 my-2">
                    {ruleset.state}
                  </div>
                </div>
                <Link
                  to={`/rulesets/create/${ruleset.id}`}
                  className="absolute -top-4 right-12 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center"
                >
                  <Copy className="h-6 w-6" />
                </Link>
                <Link
                  to={`/rulesets/${ruleset.id}`}
                  className="absolute -top-4 -right-4 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
                >
                  <Pencil className="h-6 w-6" />
                </Link>
                <SpinArrow
                  open={open}
                  className="h-8 w-8 text-primary-blue mx-2"
                />
              </Disclosure.Button>
              <ExpandingPanel open={open} endHeight={"h-52"}>
                <ol className="p-4 animate-fade mb-2">
                  {ruleset.rules.map((rule) => {
                    return (
                      <li
                        key={rule.id}
                        className="flex items-center justify-start gap-2 px-4 py-2 bg-gray-100 rounded-md mb-2"
                      >
                        <div className="flex items-center justify-center rounded-full h-6 w-6 text-white bg-red-500">
                          <div>{rule.order + 1}</div>
                        </div>{" "}
                        {rule.rule}
                      </li>
                    );
                  })}
                </ol>
              </ExpandingPanel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default RuleSetDisplay;
